import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";

export const getAllData = async (
  page,
  per_page,
  search,
  name,
  from,
  to,
  state_id,
  city_id,
  type,
) => {
  try {
    let url = `/payment/canceled-payment?`;

    if (page) {
      url += `&page=${page}`;
    }

    if (per_page) {
      url += `&per_page=${per_page}`;
    }
    if (search) {
      url += `&term=${search}`;
    }
    if (name) {
      url += `&name=${name}`;
    }

    if (from) {
      url += `&from=${from}`;
    }

    if (to) {
      url += `&to=${to}`;
    }
    if (state_id) {
      url += `&state_id=${state_id}`;
    }
    if (city_id) {
      url += `&city_id=${city_id}`;
    }
    if (type) {
      url += `&type=${type}`;
    }

    return await getData(url);
  } catch (error) {
    console.error(error);
  }
};

export const getAllReportsData = async (
  page,
  per_page,
  search,
  name,
  from,
  to,
  state_id,
  city_id,
  type,
) => {
  try {
    let url = `/payment/canceled-payment/reports?`;

    if (page) {
      url += `&page=${page}`;
    }

    if (per_page) {
      url += `&per_page=${per_page}`;
    }

    if (search) {
      url += `&term=${search}`;
    }
    if (name) {
      url += `&name=${name}`;
    }

    if (from) {
      url += `&from=${from}`;
    }

    if (to) {
      url += `&to=${to}`;
    }
    if (state_id) {
      url += `&state_id=${state_id}`;
    }
    if (city_id) {
      url += `&city_id=${city_id}`;
    }
    if (type) {
      url += `&type=${type}`;
    }

    return await getData(url);
  } catch (error) {
    console.error(error);
  }
};

export const CanceledAccepted = async (data) => {
  try {
    return await postData(`/payment/canceled-payment/accepted`, data);
  } catch (error) {
    console.error(error);
  }
};

export const CanceledRejected = async (data) => {
  try {
    return await postData(`/payment/canceled-payment/rejected`, data);
  } catch (error) {
    console.error(error);
  }
};
